var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_217_723)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.20732 13.0823C7.43405 13.1118 7.64574 13.1253 7.84369 13.1253C9.90421 13.1253 10.475 11.6499 10.7026 11.0616L10.7029 11.0609C11.1458 9.91301 11.5137 7.84038 11.6522 7.04435C11.7992 6.15957 11.6038 5.35393 11.1027 4.7755C10.6447 4.2471 9.95934 3.93711 9.17203 3.93711H6.92363C6.92363 3.93711 7.12191 3.14481 7.27121 2.55768C7.76424 0.618603 6.66868 -0.0764378 5.10855 0.00657331L2.83203 4.30337L0 5.906V11.8127L7.20732 13.0823ZM8.89725 15.2245C8.68017 14.9739 8.52047 14.6807 8.42114 14.357C9.54993 14.2739 10.3646 13.8192 10.9308 13.2349C11.5138 12.6333 11.7797 11.9453 11.9013 11.6305L11.9089 11.6109C12.3956 10.3497 12.7816 8.1845 12.9251 7.35884L12.9274 7.3507L12.9373 7.29102C12.9562 7.17746 12.9708 7.06408 12.9812 6.95088L20 8.18729V14.094L17.168 15.6966L14.8914 19.9934C13.3313 20.0764 12.2358 19.3814 12.7287 17.4423C12.8453 16.9827 12.9612 16.5229 13.0764 16.0629H10.828C10.0407 16.0629 9.35526 15.7529 8.89725 15.2245Z",
    fill: "#F7F6F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_217_723"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon02);
export default __webpack_public_path__ + "static/media/icon02.6a7c013770880527a8634c3200c11aed.svg";
export { ForwardRef as ReactComponent };